var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1452_3869)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91596 6.69039C3.91596 5.82212 4.26088 4.98941 4.87484 4.37546C5.4888 3.7615 6.3215 3.41658 7.18977 3.41658C8.05804 3.41658 8.89075 3.7615 9.5047 4.37546C10.1187 4.98941 10.4636 5.82212 10.4636 6.69039C10.4636 7.55866 10.1187 8.39136 9.5047 9.00532C8.89075 9.61928 8.05804 9.9642 7.18977 9.9642C6.3215 9.9642 5.4888 9.61928 4.87484 9.00532C4.26088 8.39136 3.91596 7.55866 3.91596 6.69039ZM7.18977 2.10706C6.46381 2.10706 5.74823 2.2795 5.10197 2.6102C4.4557 2.94089 3.89723 3.42036 3.47254 4.00914C3.04785 4.59792 2.7691 5.27916 2.65924 5.99676C2.54937 6.71436 2.61154 7.44779 2.84061 8.13666C3.06969 8.82553 3.45913 9.45013 3.97685 9.95903C4.49458 10.4679 5.12578 10.8466 5.81849 11.0638C6.5112 11.281 7.24559 11.3305 7.96119 11.2083C8.6768 11.0862 9.35314 10.7957 9.93453 10.361L13.2738 13.7009C13.3966 13.8238 13.5631 13.8928 13.7368 13.8929C13.9105 13.893 14.0771 13.824 14.2 13.7013C14.3228 13.5785 14.3919 13.4119 14.392 13.2382C14.392 13.0645 14.3231 12.898 14.2003 12.7751L10.861 9.4358C11.3706 8.75454 11.6806 7.94486 11.7561 7.09743C11.8317 6.25 11.6699 5.39827 11.2888 4.63758C10.9078 3.8769 10.3225 3.23729 9.59857 2.79037C8.87462 2.34344 8.04056 2.10684 7.18977 2.10706Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1452_3869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7143,
    height: 15.7143,
    fill: "white",
    transform: "translate(0.642578 0.142822)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.91a869b4596d01a1a4fb803d1ec69262.svg";
export { ForwardRef as ReactComponent };